import normalizeText from './normalizeText';

const getBaseTitle = ({ text, operator, isSingle = false }) => {
  const isEmptyOpetator = operator === 'allOf'
  || operator === 'oneOf'
  || operator === 'oneOfExceptOneOf'
  || operator === 'oneOfExceptAllOf'
  || operator === 'allOfExceptAllOf'
  || operator === 'allOfExceptOneOf';

  const normalizedText = normalizeText(text);
  const operatorLabels = {
    noneOf: 'None of',
    contains: 'Contains:',
    startsWith: 'Starts with:',
    endsWith: 'Ends with:',
    notEquals: 'Not',
  };

  const prefix = operatorLabels[operator] || '';
  const suffix = isSingle || isEmptyOpetator ? '' : ', ';

  return prefix ? `${prefix} ${normalizedText}${suffix}` : `${normalizedText}${suffix}`;
};

export default getBaseTitle;
